import { styled } from '@linaria/react';
import { breakpoints, layout, space } from '../../theme/tokens';

export const HeadingArea = styled.div`
  padding: 0 0 ${space[7]};

  & h1 {
    max-width: 12.5em;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-top: ${space['20px']};
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding-right: ${space[8]};
    padding-left: ${space[8]};
  }
`;

export const GridArea = styled.div`
  @media (min-width: ${breakpoints.desktop}) {
    padding: 0
      clamp(0px, calc((100vw - ${breakpoints.desktop}) * 0.6), calc(${space[10]} + ${space[8]}));
  }
`;
